<template>
  <div class="rules">
    <div v-for="(item,index) in content" :key="index">
      <div v-html="item.content">
      <!-- {{$t('RightsandObligationsbody')}} -->
      </div>
    </div>
    

    <!-- <h4 class="headtitle">{{$t('DisputeSettlement')}}</h4>
    <div class="boxs" v-html="content.disputeHandle">
     {{$t('DisputeSettlementbody')}}
    </div>

    <h4 class="headtitle">{{$t('Validityandinterpretationright')}}</h4>
    <div class="boxs" v-html="content.effectInterpretation">
      {{$t('Validityandinterpretationrightbody')}}
    </div> -->
  </div>
  
</template>

<script>
export default {
  data(){
    return {
      contactusList:[],
      content:{}
    }
  },
  created(){
    this.$getHttp("pc/EntryRequirements/getEntryRequirements").then((res) => {
      if (res.success) {
       
        this.content = res.data;

      } else {
        this.$message({
          message: res.msg,
        });
      }
    });
  },
}
</script>

<style lang="less">
  .rules{
    text-align: left;
    .headtitle{
      position: relative;
      font-size: 26px;
      font-family: PingFang SC-Regular, PingFang SC;
      color: #333333;
      font-weight: 500;
      padding-left: 20px;
      margin-left: 5px;
      margin-top: 6px;
      margin-bottom: 25px;
      // &:before{
      //   position: absolute;
      //   content: '';
      //   left: 0;
      //   top:50%;
      //   transform: translateY(-50%);
      //   width: 4px;
      //   height: 24px;
      //   background: #6F73F4;
      //   border-radius: 2px 2px 2px 2px;
      // }
    }
    // .boxs{
    //   font-size: 22px;
    //   font-family: PingFang SC-Regular, PingFang SC;
    //   font-weight: 400;
    //   color: #333333;
    //   line-height: 50px;
    //   margin-bottom: 60px;
    //   white-space: pre-line
    // }
  }
</style>